<template>
<svg viewBox="0 0 48 48" :fill="useCurrentColor ? 'currentColor' : 'currentColor'" :class="[`${prefix}-icon`, `${prefix}-icon-english`]" width="1em" height="1em" v-bind="$attrs"><path fill-rule="evenodd" clip-rule="evenodd" d="M44 6a2 2 0 00-2-2H6a2 2 0 00-2 2v36a2 2 0 002 2h36a2 2 0 002-2V6zM8 8h32v32H8V8zm14 6a1 1 0 011 1v1.998a1 1 0 01-.883.993l-.119.007L14 17.982V21h7a1 1 0 011 1v2a1 1 0 01-1 1h-7v4h8a1 1 0 011 1v2a1 1 0 01-1 1H11a1 1 0 01-1-1V15a1 1 0 011-1h11zm16 12.5a6.5 6.5 0 10-13 0V33h4v-6.5a2.5 2.5 0 015 0V33h4v-6.5z"/></svg>
</template>
<script>

export default {
  name: 'IconEnglish',
  props: {
    prefix: {
        type: String,
        default: 'm',
    },
    useCurrentColor: {
        type: Boolean,
        default: false,
    },
  },
};
</script>
